/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Device_BrowserInputs */

const en_why_listening_device_browser = /** @type {(inputs: Why_Listening_Device_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser`)
};

const es_why_listening_device_browser = /** @type {(inputs: Why_Listening_Device_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegador`)
};

/**
* | output |
* | --- |
* | "Browser" |
*
* @param {Why_Listening_Device_BrowserInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_device_browser = /** @type {((inputs?: Why_Listening_Device_BrowserInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Device_BrowserInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_device_browser(inputs)
	return en_why_listening_device_browser(inputs)
});